module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.svgName
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.xlinkName
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-eaec9412!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/roller/die.vue
// module id = 115
// module chunks = 2